module.exports = __webpack_public_path__ + "static/media/toolslogo.f84993f2.svg";